import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import range from 'lodash/range';
import a from '../../../../../redux/actions';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';
import units from '../../../../../lib/units';

import InlineSelect from '../InlineSelect';
import numericInput from '../../../../../lib/numericInput';

const percentReductionOptions = t => range(0, 110, 10).map(value => ({
  value,
  display: t('{{amount}}%', { amount: value }),
}));

const ReduceAirTravel = ({
  t,
  widgetSource,
  isMetric,
  resultTakeactionReduceAirTravelTotalmiles,
  resultTakeactionReduceAirTravelPoundsFromFlight,
  resultTakeactionReduceAirTravelMilesAlt,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: t('I fly about {{resultTakeactionReduceAirTravelTotalmiles}} {{distanceUnits}} per year, which produces about {{resultTakeactionReduceAirTravelPoundsFromFlight}} tons of CO<sub>2</sub>eq per year. I will fly about', {
              resultTakeactionReduceAirTravelTotalmiles,
              distanceUnits: isMetric ? t('kilometers', { ns: 'units' }) : t('miles', { ns: 'units' }),
              resultTakeactionReduceAirTravelPoundsFromFlight,
            }),
          }}
        />
        <InlineSelect
          options={percentReductionOptions(t)}
          apiKey={'input_takeaction_reduce_air_travel_miles_percent'}
        />
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: t('or {{resultTakeactionReduceAirTravelMilesAlt}} fewer {{distanceUnits}} by teleconferencing or staying home.', {
              distanceUnits: isMetric ? t('kilometers', { ns: 'units' }) : t('miles', { ns: 'units' }),
              resultTakeactionReduceAirTravelMilesAlt,
            }),
          }}
        />
      </p>
    </div>
    <div
      className="action-details__facts"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: t('Travelling virtually is one of the best things you can do to reduce you impacts because every two-hours flight avoided saves as much as avoiding a month of typical driving.'),
      }}
    />
    {widgetSource !== 'ontario' && <div className="action-details__links">
      <a
        href="http://www.coolcalifornia.org/funding-wizard#search//%255BZipcode%253D%253D94720%255D%255BCategory%253D%253DTransportation%255D%255BEligible+Applicants%253D%253DIndividual%255D/false/none/false/1/12"
        target="_blank"
        rel="noopener noreferrer"
      >{t('Find rebates and incentives for this action')}</a>
    </div>}
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          <span
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: t('Flying produces {{value}} grams of CO<sub>2</sub>eq/ passenger-{{distanceUnits}}, on average', {
                value: numericInput.format(isMetric ? units.miToKm(223) : 223),
                distanceUnits: isMetric ? t('km', { ns: 'units' }) : t('mi', { ns: 'units' }),
              }),
            }}
          />
          &nbsp;
          (<a
            href="http://ghgprotocol.org/"
            target="_blank"
            rel="noopener noreferrer"
          >{t('WRI-WBCSD')}</a>).
        </li>
        <li>
          {t('Indirect emissions (from contrails and other atmospheric effects) account for 50% of total emissions')}
        </li>
      </ul>
    </div>
  </div>
);

ReduceAirTravel.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  isMetric: PropTypes.bool.isRequired,
  widgetSource: PropTypes.string.isRequired,
  resultTakeactionReduceAirTravelTotalmiles: PropTypes.string.isRequired,
  resultTakeactionReduceAirTravelPoundsFromFlight: PropTypes.string.isRequired,
  resultTakeactionReduceAirTravelMilesAlt: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'resultTakeactionReduceAirTravelTotalmiles',
  'resultTakeactionReduceAirTravelPoundsFromFlight',
  'resultTakeactionReduceAirTravelMilesAlt',
].reduce((resultProps, resultKey) => ({
  ...resultProps,
  [resultKey]: s.results(resultKey)(state, ownProps),
}), {
  isMetric: s.isMetric(state),
  widgetSource: s.widgetSource(state),
});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('reduceAirTravel'),
  connect(mapStateToProps, mapDispatchToProps)(ReduceAirTravel),
);
